export { ReactComponent as SvgLinkTr } from 'public/assets/icons/link-triangle.svg';
export { ReactComponent as SvgDatePicker } from 'public/assets/icons/datepicker.svg';
export { ReactComponent as SvgEye } from 'public/assets/icons/eye.svg';
export { ReactComponent as SvgFHReport } from 'public/assets/icons/fh-report.svg';
export { ReactComponent as SvgCalendar } from 'public/assets/icons/calendar.svg';
